const Config = {
    STORAGE_KEY: "/omnibus/special/impression",
    CLEAR_NUM: 69000,
    GOOD_PER__ADD: 300, // KVのGOODアイコンをいくつごとに増やすか
};

export default Config;
